import { useSelector } from "react-redux";
import { format } from 'date-fns';

export default function useFormat() {
  
    const currency          = useSelector(state => state.region.region) || 'AED';
    const roundingPrecision = 2;
    // const selectedWarehouse = warehouses.find(warehouse => warehouse.value === currency);
    // const roundingPrecision = selectedWarehouse?.rounding_precision ?? 2;

    const formatPrice = (price = 0, opts = { hideZeroFraction: false, hideCurrency: false }) => {
        const { hideZeroFraction = false, hideCurrency = false } = opts || {};
        let multiplier           = Math.pow(10, roundingPrecision);

        let formattedPrice = (Math.round(Number(price) * multiplier) / multiplier).toFixed(roundingPrecision);

        if (hideZeroFraction) {
            const parts = formattedPrice.split('.');
            if (parts[1] && parseInt(parts[1], 10) === 0) {
                formattedPrice = parts[0];
            }
        }

        formattedPrice = (Math.ceil(formattedPrice / 0.05) * 0.05).toFixed(roundingPrecision);

        if (hideCurrency) {
            return formattedPrice;
        } else {
            return `${currency} ${formattedPrice}`;
        }        
    };

    const formatDate = (time = 0, opts) => {
        if (!time) return null;

        const { hideYear = false } = opts || {};

        if (hideYear) return format(new Date(time), 'dd.MM');
        return format(new Date(time), 'dd.MM.yyyy');
    };


    return {
        formatPrice,
        formatDate
    };
}
